import "react-flow-renderer/dist/style.css";
import "react-flow-renderer/dist/theme-default.css";
import { StylesProvider } from "@material-ui/core";
import { SnackbarProvider } from "notistack";
import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";

import "./index.css";
import App from "./App";
import store from "./store";

render(
  <StylesProvider injectFirst>
    <Provider store={store}>
      <SnackbarProvider
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <App />
      </SnackbarProvider>
    </Provider>
  </StylesProvider>,
  document.querySelector("#app")
);
